//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../ApiService";

const EditService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/oralbook/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    save: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/oralbook/edit/save", vo, successCallback, failureCallback);
    }
};

export default EditService;